export default __webpack_public_path__ + "static/media/success-logo.05fd96fe.svg";